import { GDPRSdk } from "@ciaopeople/cp-shatsu/GDPR";
import { ExternallyPassedContentAdData } from "../../../ads/adcall/composable/ContentSpecificAdCallFilter.js";
import { PlayerEvent } from "../../../events/PlayerEvent.js";
import { AudicomConfig } from "../AudicomPairingPing.js";
import { ComScoreConfig, ComScoreStreamingTag, ComScoreStreamingTagFactory } from "./ComScoreStreamingTag.js";
import { NoOpComScoreStreamingTagFactory } from "./ComScoreNoOp.js";

export class ComScoreStreamingTagDynamic implements ComScoreStreamingTagFactory {

    private prom: Promise<ComScoreStreamingTagFactory>;

    constructor(private cfg: ComScoreConfig,
        private gdprPromise: Promise<GDPRSdk>,
        private window: Window,
        private extData?: ExternallyPassedContentAdData,
        private audicom?: AudicomConfig) {

    }


    private getIt(): Promise<ComScoreStreamingTagFactory> {
        if (!this.prom) {
            this.prom = this.gdprPromise.then(gdpr => {
                // Opt-out volumetrica in contesto Audicom: non carichiamo nemmeno il
                // chunk "ComScoreModule" (che include il vendor Comscore), così in
                // opt-out non viene scaricato alcun JS di tracciamento. Restituiamo
                // un factory no-op. (Doc E, Caso 5 — coerente col gate in ComScoreStreamingTagImpl.)
                const isVolumetricOptOut = !gdpr.audicom.volumetricEnabled();
                if (this.audicom && isVolumetricOptOut) {
                    console.log("[AUDICOM] Opt-out volumetrica: modulo/chunk Comscore non caricato");
                    return new NoOpComScoreStreamingTagFactory();
                }
                return import(/* webpackChunkName: "ComScoreModule" */"./ComScoreStreamingTagModule").then(fn => {
                    return fn.getComScoreStreamingTagFactory(this.cfg, this.gdprPromise, this.window, this.extData, this.audicom);
                });
            });
        }
        return this.prom;
    }

    getStreamingTag(mle: PlayerEvent): Promise<ComScoreStreamingTag> {
        return this.getIt().then(stf => stf.getStreamingTag(mle));
    }




    preload(): Promise<ComScoreStreamingTagFactory> {
        return this.getIt();
    }
}